import type { Component } from 'vue'

import type { Variants as InfoVariants } from '@ds/components/InfoBlock/InfoBlock.constant'
import type { Variants as TagVariants } from '@ds/components/Tag/Tag.constant'

import { STATUS_COLORS, STATUS_ICONS } from './TaxDetails.constants'
import type { StatusColorKey, StatusIconKey } from './TaxDetails.types'

export function getStatusTagVariant(status: StatusColorKey | string) {
  return (STATUS_COLORS[status as StatusColorKey] || '') as TagVariants
}

export function getStatusInfoVariant(status: StatusColorKey | string) {
  return (STATUS_COLORS[status as StatusColorKey] || '') as InfoVariants
}

export function getStatusIcon(status: StatusIconKey | string) {
  return STATUS_ICONS[status as StatusIconKey] as Component
}
